module.exports = [{
      plugin: require('/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-pay-frontend/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-pay-frontend/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
